/* ZEPHIR - Recogida en tienda: el mapa y "la tienda mas cercana".
 *
 * Pedido del cliente: "trabajemos en el recoge en tienda tipo el de zara que
 * sale un mapa donde puedo colocar mi ubicacion y me dice en que tienda esta
 * disponible para yo elegirla o saber donde puedo".
 *
 * ===========================================================================
 * QUE HABIA YA, Y QUE ANADE ESTE ARCHIVO
 * ===========================================================================
 * El bloque custom_liquid_cNAHEf de templates/product.json hace tres cosas y las
 * hace bien: pide sections/pickup-availability.liquid por fetch cuando cambia la
 * variante, lo inyecta, y abre/cierra la ventana anadiendo y quitando la clase
 * `is--open` (boton, aspa y Escape). AQUI NO SE REIMPLEMENTA NADA DE ESO. Este
 * archivo solo anade lo que faltaba: el mapa, las distancias, el orden por
 * cercania, un fondo oscuro y el bloqueo del scroll.
 *
 * LA UNICA FUENTE DE VERDAD DEL ESTADO ES LA CLASE `is--open`. El fondo y el
 * bloqueo del scroll se sincronizan con un MutationObserver sobre esa clase, no
 * con nuestros propios clics. Es deliberado: el JS del bloque tambien cierra la
 * ventana (por ejemplo al pulsar el relleno de la propia ventana), y si
 * dependieramos de nuestros clics, ese cierre nos dejaria la pagina bloqueada sin
 * poder desplazarla. Sincronizando contra la clase, cierre quien cierre, el fondo
 * se va y el scroll vuelve.
 *
 * ===========================================================================
 * POR QUE ESTE CODIGO NO VIVE EN LA SECCION
 * ===========================================================================
 * La seccion se inyecta con `holder.innerHTML`. LOS <script> INSERTADOS CON
 * innerHTML NO SE EJECUTAN: es una regla del navegador. Asi que la seccion aporta
 * solo datos en atributos data-* y el comportamiento vive aqui, cargado en la
 * ficha desde sections/zephir-fonts.liquid.
 *
 * Y OJO CON LO QUE INYECTA: el holder se queda con el CONTENIDO de la seccion, no
 * con su envoltorio. .t4s-pickup-availability-container NO EXISTE en el DOM
 * (comprobado: querySelectorAll devuelve 0). El contenedor real es
 * .t4s-zephir-fulfillment__row -- el mismo que lleva data-pickup-holder -- y
 * dentro van, como hermanos, el bloque de informacion y la ventana.
 *
 * Consecuencia practica: el marcado APARECE TARDE y REAPARECE al cambiar de talla
 * o color. Por eso todo va con delegacion de eventos en `document`, y las marcas
 * de "ya montado" son propiedades JS del nodo y no atributos: un atributo se
 * copiaria a un clon y lo dejaria marcado como listo pero sin comportamiento.
 *
 * ===========================================================================
 * LA VENTANA SE MUEVE AL <body>
 * ===========================================================================
 * La ventana vive dentro de .t4s-product__info-container--sticky, que tiene un
 * transform. Cualquier transform distinto de `none` convierte al elemento en el
 * marco de referencia de sus descendientes position:fixed, asi que una ventana
 * centrada ahi dentro se arrastraria con la columna al hacer scroll. Al abrirla
 * se traslada al <body>; si luego la ficha reinyecta la seccion (cambio de
 * variante), la nueva ventana manda y la vieja -- que ya habla de otra variante --
 * se retira del <body>.
 *
 * ===========================================================================
 * DONDE ESTAN LAS TIENDAS: EN EL <ul>, NO DENTRO DE [data-zpk]
 * ===========================================================================
 * Error que cometi la primera vez y que no dio ninguna senal: buscaba los
 * [data-zpk-item] DENTRO de la caja del mapa. Pero [data-zpk] solo contiene el
 * boton y el hueco del mapa; las tiendas son los <li> del <ul> que va DEBAJO.
 * Encontraba cero tiendas, no pintaba ningun alfiler y dejaba el mapa escondido,
 * sin lanzar ningun error. De ahi raizDe(): se sube a la ventana y busca desde
 * ahi.
 *
 * ===========================================================================
 * OPENSTREETMAP CON LEAFLET, Y NO GOOGLE MAPS
 * ===========================================================================
 * Google Maps pide clave de API y tarjeta, y cobra por carga de mapa. Para siete
 * tiendas en Bogota no compensa. Leaflet + OpenStreetMap no piden clave ni
 * facturacion, y el "usar mi ubicacion" es la API de geolocalizacion del
 * NAVEGADOR, que no depende del proveedor del mapa.
 *
 * LA LIBRERIA SE CARGA AL ABRIR LA VENTANA, no con la pagina: son ~55 KB entre
 * JS y CSS que la mayoria de las visitas no necesita.
 *
 * SE USAN circleMarker Y NO LOS ALFILERES POR DEFECTO. Los iconos de Leaflet son
 * PNG que la libreria busca en una ruta relativa a su CSS; en un tema de Shopify
 * eso suele acabar en 404 y alfileres invisibles. circleMarker es vectorial.
 *
 * SE ESPERA A QUE EL HUECO TENGA TAMANO ANTES DE ARRANCAR EL MAPA. La ventana
 * nace en display:none, y Leaflet arrancado sobre un contenedor de 0x0 calcula un
 * zoom infinito en fitBounds y se rompe. conTamano() sondea hasta que el hueco
 * mide de verdad; si nunca mide, se rinde en silencio y no se ensena nada roto.
 *
 * scrollWheelZoom VA APAGADO: en una ventana, un mapa que captura la rueda
 * secuestra el desplazamiento y la clienta se queda atrapada.
 *
 * ===========================================================================
 * LO QUE PASA CUANDO ALGO FALLA -- que es la mitad del trabajo
 * ===========================================================================
 * El mapa es un ADORNO sobre una lista que ya funciona. Por orden de gravedad:
 *
 *  - Si este JS no corre: la ventana se sigue abriendo (eso lo hace el bloque de
 *    la ficha) con la lista completa de tiendas, direcciones, telefonos y enlace
 *    a Google Maps. Se pierde el mapa y el fondo oscuro, nada mas.
 *  - Si la libreria del mapa no carga (red, CDN, bloqueador): se esconde el mapa
 *    pero el boton SIGUE funcionando -- las distancias y el orden no necesitan
 *    Leaflet, solo geolocalizacion y aritmetica.
 *  - Si una tienda no tiene coordenadas (Shopify devuelve nil cuando la direccion
 *    no esta verificada): se queda sin alfiler y sin distancia, ordenada al final,
 *    pero sigue en la lista con su direccion.
 *  - Si la geolocalizacion se deniega o falla: se dice por que, en una frase, y
 *    la lista se queda como estaba. Nunca se deja el boton girando.
 *
 * LAS DISTANCIAS SON EN LINEA RECTA (formula del semiverseno), no de conduccion.
 * Se dice "en linea recta" en el aviso para no prometer un tiempo de viaje que no
 * calculamos.
 *
 * ===========================================================================
 * 24 HORAS O 2 DIAS: EL PLAZO REAL LO PONE EL HUB (2026-09-14)
 * ===========================================================================
 * Shopify marca "disponible" una tienda con 0 unidades si la prenda puede
 * llegar por traslado (StoreAvailability: "includes inventory that can be
 * moved to the location through a store transfer route"). Regla del cliente:
 * con stock fisico en la tienda -> "24 horas"; sin el -> "2 dias".
 *
 * El stock por tienda lo sabe el Hub (Siesa es la fuente de verdad), que expone
 * GET /api/publico/disponibilidad?variant=<id> con {disponible: true|false} por
 * shopify_location_id. Aqui se pide UNA vez por variante (cache en memoria), se
 * cruza con data-location-id de cada <li> y se reescriben los textos:
 *   - lista:   [data-zpk-estado]   "Recogida disponible, lista en 24 horas" /
 *                                  "Disponible en 2 dias, llega desde otra tienda"
 *   - titular: [data-zpk-cab-nombre] + [data-zpk-cab-plazo]: la primera tienda
 *              que la tiene HOY; si ninguna, la primera por traslado.
 *   - mapa y "mas cercana": prefieren las tiendas que la tienen hoy.
 * SHOPIFY SIGUE MANDANDO EN EL "NO": si Shopify dice no disponible, no se toca.
 * SI EL HUB FALLA O TARDA (>6 s), SE QUEDA EL TEXTO DE SHOPIFY: lo de siempre.
 * Un fallo se recuerda 60 s para no martillear al Hub al cambiar de talla.
 * La lista aparece por innerHTML tras un fetch del bloque de la ficha, asi que
 * se detecta con un MutationObserver (con un pequeno debounce) y ademas al
 * abrir la ventana, por si el observer no estuviera disponible.
 */
(function () {
  'use strict';

  var CSS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  var JS_URL  = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  var TINTA = '#161616';
  var CIRUELA = '#714964';

  var POPUP_SEL  = '.t4s-pickup-availability-popup';
  var HOLDER_SEL = '[data-pickup-holder]';
  var ABIERTA    = 'is--open';

  var estadoLib = 0;           // 0 sin intentar, 1 cargando, 2 lista, 3 fallo
  var enEspera = [];

  function cargarLibreria(cb) {
    if (estadoLib === 2) { cb(true); return; }
    if (estadoLib === 3) { cb(false); return; }
    enEspera.push(cb);
    if (estadoLib === 1) return;
    estadoLib = 1;

    function terminar(ok) {
      estadoLib = ok ? 2 : 3;
      var cs = enEspera; enEspera = [];
      for (var i = 0; i < cs.length; i++) { try { cs[i](ok); } catch (e) {} }
    }

    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = CSS_URL;
    document.head.appendChild(css);

    var s = document.createElement('script');
    s.src = JS_URL;
    s.async = true;
    s.onload = function () { terminar(!!window.L); };
    s.onerror = function () { terminar(false); };
    document.head.appendChild(s);

    /* Red de seguridad: si ni onload ni onerror llegan (pasa con algunos
       bloqueadores, que dejan la peticion colgada), no se espera para siempre. */
    setTimeout(function () { if (estadoLib === 1) terminar(!!window.L); }, 7000);
  }

  /* ======================= FONDO Y BLOQUEO DEL SCROLL ======================= */
  var fondo = null;

  function elFondo() {
    if (fondo && fondo.parentNode) return fondo;
    fondo = document.createElement('div');
    fondo.className = 'zpk-fondo';
    fondo.setAttribute('data-zpk-fondo', '');
    fondo.hidden = true;
    document.body.appendChild(fondo);
    return fondo;
  }

  /* Se sincroniza contra la clase, no contra nuestros clics: cierre quien cierre
     -- nuestro fondo, el aspa, Escape o el JS del bloque -- el fondo se va y el
     scroll vuelve. */
  function sincronizar(pop) {
    var abierta = pop.classList.contains(ABIERTA);
    elFondo().hidden = !abierta;
    if (abierta) document.documentElement.classList.add('zpk-modal-abierto');
    else document.documentElement.classList.remove('zpk-modal-abierto');
  }

  function vigilar(pop) {
    if (pop.__zpkObs || typeof MutationObserver !== 'function') return;
    pop.__zpkObs = new MutationObserver(function () { sincronizar(pop); });
    pop.__zpkObs.observe(pop, { attributes: true, attributeFilter: ['class'] });
  }

  /* Que ventana corresponde a este boton. Si el holder trae una recien inyectada,
     esa manda y se retira del <body> la que hubieramos movido antes: hablaba de
     otra variante. Si el holder no trae ninguna, es que ya la movimos nosotros. */
  function ventanaDe(boton) {
    var holder = (boton.closest && boton.closest(HOLDER_SEL)) || boton.parentElement;
    var fresca = holder ? holder.querySelector(POPUP_SEL) : null;
    var movidas = document.querySelectorAll('body > [data-zpk-movida]');
    if (fresca) {
      for (var i = 0; i < movidas.length; i++) {
        if (movidas[i] !== fresca && movidas[i].parentNode) movidas[i].parentNode.removeChild(movidas[i]);
      }
      return fresca;
    }
    return movidas.length ? movidas[movidas.length - 1] : null;
  }

  function abrir(pop) {
    if (!pop) return;
    if (pop.parentNode !== document.body) {
      pop.setAttribute('data-zpk-movida', '');
      document.body.appendChild(pop);
    }
    vigilar(pop);
    pop.classList.add(ABIERTA);   /* el JS del bloque la anade tambien; es idempotente */
    sincronizar(pop);

    var cierre = pop.querySelector('[data-pickup-close]');
    if (cierre) { try { cierre.focus({ preventScroll: true }); } catch (e) { try { cierre.focus(); } catch (e2) {} } }
  }

  function cerrarTodo() {
    var abiertas = document.querySelectorAll(POPUP_SEL + '.' + ABIERTA);
    for (var i = 0; i < abiertas.length; i++) {
      abiertas[i].classList.remove(ABIERTA);
      sincronizar(abiertas[i]);
    }
    elFondo().hidden = true;
    document.documentElement.classList.remove('zpk-modal-abierto');
  }

  /* ============================== LAS TIENDAS =============================== */
  /* La caja del mapa y la lista son HERMANAS, no anidadas: hay que subir a la
     ventana para encontrar los <li>. */
  function raizDe(caja) {
    return (caja.closest && caja.closest(POPUP_SEL)) || caja.parentNode || document;
  }

  function tiendas(caja) {
    var items = raizDe(caja).querySelectorAll('[data-zpk-item]');
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var lat = parseFloat(items[i].getAttribute('data-lat'));
      var lng = parseFloat(items[i].getAttribute('data-lng'));
      var st = items[i].getAttribute('data-zpk-stock');
      out.push({
        el: items[i],
        nombre: items[i].getAttribute('data-nombre') || '',
        disponible: items[i].getAttribute('data-disponible') === '1',
        stock: st === '1' ? true : st === '0' ? false : null,   // null: el Hub no ha dicho
        lat: lat, lng: lng,
        tieneCoords: isFinite(lat) && isFinite(lng) && (lat !== 0 || lng !== 0)
      });
    }
    return out;
  }

  function conCoordenadas(lista) {
    var out = [];
    for (var i = 0; i < lista.length; i++) if (lista[i].tieneCoords) out.push(lista[i]);
    return out;
  }

  /* ---------- distancia en linea recta, sin librerias ---------- */
  function km(aLat, aLng, bLat, bLng) {
    var R = 6371, rad = Math.PI / 180;
    var dLat = (bLat - aLat) * rad, dLng = (bLng - aLng) * rad;
    var la1 = aLat * rad, la2 = bLat * rad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  function comoTexto(d) {
    if (d < 1) return 'a ' + Math.round(d * 1000) + ' m';
    return 'a ' + d.toFixed(1).replace('.', ',') + ' km';
  }

  /* ---------- esperar a que el hueco mida de verdad ---------- */
  function conTamano(el, cb, n) {
    n = n || 0;
    if (el.offsetWidth > 0 && el.offsetHeight > 0) { cb(true); return; }
    if (n > 100) { cb(false); return; }   // ~10 s y se rinde
    setTimeout(function () { conTamano(el, cb, n + 1); }, 100);
  }

  /* ================================= EL MAPA ================================ */
  function pintarMapa(el, lista) {
    var mapa = window.L.map(el, { scrollWheelZoom: false, zoomControl: true });
    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>'
    }).addTo(mapa);

    var puntos = [];
    for (var j = 0; j < lista.length; j++) {
      var t = lista[j];
      var m = window.L.circleMarker([t.lat, t.lng], {
        radius: 7,
        color: t.disponible ? TINTA : '#9a9a9a',
        weight: 2,
        fillColor: t.disponible ? TINTA : '#ffffff',
        fillOpacity: t.disponible ? 1 : 0.9
      }).addTo(mapa);
      m.bindPopup(globo(t.nombre, t.disponible, t.stock));
      /* El alfiler se guarda EN EL <li>, no en un array aparte: la lista se
         recalcula en cada uso y asi el par tienda-alfiler nunca se descuadra. */
      t.el.__zpkMarcador = m;
      puntos.push([t.lat, t.lng]);
    }

    /* fitBounds es lo que se rompe si el contenedor mide 0; aqui ya mide, pero
       aun asi se protege: un mapa centrado a mano es mejor que ningun mapa. */
    try { mapa.fitBounds(puntos, { padding: [24, 24], maxZoom: 14 }); }
    catch (e) { mapa.setView(puntos[0], 12); }

    setTimeout(function () { try { mapa.invalidateSize(); } catch (e) {} }, 60);
    return mapa;
  }

  function preparar(caja) {
    /* Propiedad JS y no atributo: si alguien clona la ventana, el clon llega sin
       la marca y se monta solo. */
    if (caja.__zpkListo) {
      if (caja.__zpkMapa) setTimeout(function () { try { caja.__zpkMapa.invalidateSize(); } catch (e) {} }, 120);
      return;
    }
    caja.__zpkListo = true;

    var mapaEl = caja.querySelector('[data-zpk-mapa]');

    /* Se ensena la barra (el boton sirve por si solo) pero NO el mapa hasta que
       la libreria este: asi no aparece un rectangulo gris vacio. */
    caja.removeAttribute('hidden');
    if (!mapaEl) return;
    mapaEl.setAttribute('hidden', '');

    if (!conCoordenadas(tiendas(caja)).length) return;  // sin coordenadas, la lista basta

    cargarLibreria(function (ok) {
      if (!ok) return;
      mapaEl.removeAttribute('hidden');
      conTamano(mapaEl, function (mide) {
        if (!mide) { mapaEl.setAttribute('hidden', ''); return; }
        try { caja.__zpkMapa = pintarMapa(mapaEl, conCoordenadas(tiendas(caja))); }
        catch (e) { mapaEl.setAttribute('hidden', ''); }
      });
    });
  }

  /* ==================== "ver la tienda mas cercana" ========================= */
  function ubicar(caja, boton) {
    var aviso = caja.querySelector('[data-zpk-aviso]');

    if (!navigator.geolocation) {
      if (aviso) aviso.textContent = 'Este navegador no puede darnos tu ubicación. Las direcciones están abajo.';
      boton.disabled = true;
      return;
    }

    var textoOriginal = boton.textContent;
    boton.disabled = true;
    boton.textContent = 'Buscando…';
    if (aviso) aviso.textContent = '';

    navigator.geolocation.getCurrentPosition(function (pos) {
      boton.textContent = textoOriginal;
      boton.disabled = false;

      var yo = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      var lista = tiendas(caja);
      var cuantas = 0, masCerca = null;

      for (var i = 0; i < lista.length; i++) {
        var t = lista[i];
        if (!t.tieneCoords) { t.km = Infinity; continue; }
        cuantas++;
        t.km = km(yo.lat, yo.lng, t.lat, t.lng);
        var d = t.el.querySelector('[data-zpk-dist]');
        if (d) { d.textContent = comoTexto(t.km); d.removeAttribute('hidden'); }
        /* Primero las que la tienen HOY (stock true), luego las de traslado. */
        if (t.disponible && (!masCerca || rango(t) < rango(masCerca) || (rango(t) === rango(masCerca) && t.km < masCerca.km))) masCerca = t;
      }

      if (!cuantas) {
        if (aviso) aviso.textContent = 'No tenemos las coordenadas de las tiendas. Las direcciones están abajo.';
        return;
      }

      /* Ordenar la lista por cercania MOVIENDO los nodos, no con CSS: aqui si
         importa el orden de lectura -- quien usa lector de pantalla tiene que
         oir primero la tienda mas cercana. Este <ul> lo pinta nuestra seccion y
         ningun script del tema depende de su orden. */
      var ul = raizDe(caja).querySelector('[data-zpk-lista]');
      if (ul) {
        var ordenadas = lista.slice().sort(function (a, b) { return a.km - b.km; });
        for (var k = 0; k < ordenadas.length; k++) ul.appendChild(ordenadas[k].el);
      }

      for (var m = 0; m < lista.length; m++) lista[m].el.classList.remove('is-zpk-cerca');
      if (masCerca) {
        masCerca.el.classList.add('is-zpk-cerca');
        if (aviso) {
          if (masCerca.stock === true) {
            aviso.textContent = 'La más cercana que la tiene hoy: ' + masCerca.nombre + ', ' + comoTexto(masCerca.km) + ' en línea recta.';
          } else if (masCerca.stock === false) {
            aviso.textContent = 'Ninguna tienda la tiene hoy. La más cercana para recogerla en 2 días: ' + masCerca.nombre + ', ' + comoTexto(masCerca.km) + ' en línea recta.';
          } else {
            aviso.textContent = 'La más cercana con esta prenda: ' + masCerca.nombre + ', ' + comoTexto(masCerca.km) + ' en línea recta.';
          }
        }
      } else if (aviso) {
        aviso.textContent = 'Ninguna de estas tiendas tiene la prenda ahora mismo.';
      }

      /* Y en el mapa: un punto para la clienta y encuadre con la mas cercana. */
      var mapa = caja.__zpkMapa;
      if (mapa && window.L) {
        try {
          if (caja.__zpkYo) mapa.removeLayer(caja.__zpkYo);
          caja.__zpkYo = window.L.circleMarker([yo.lat, yo.lng], {
            radius: 6, color: CIRUELA, weight: 2, fillColor: CIRUELA, fillOpacity: 1
          }).addTo(mapa).bindPopup('<span class="zpk__globo"><b>Estás aquí</b></span>');

          if (masCerca && masCerca.tieneCoords) {
            mapa.fitBounds([[yo.lat, yo.lng], [masCerca.lat, masCerca.lng]], { padding: [30, 30], maxZoom: 15 });
            if (masCerca.el.__zpkMarcador) masCerca.el.__zpkMarcador.openPopup();
          } else {
            mapa.setView([yo.lat, yo.lng], 13);
          }
        } catch (e) { /* el mapa es adorno; las distancias ya estan puestas */ }
      }
    }, function (err) {
      boton.textContent = textoOriginal;
      boton.disabled = false;
      if (!aviso) return;
      if (err && err.code === 1) {
        aviso.textContent = 'No nos diste permiso de ubicación. Puedes ver las direcciones abajo.';
      } else if (err && err.code === 3) {
        aviso.textContent = 'Tardó demasiado en ubicarte. Prueba otra vez o mira las direcciones abajo.';
      } else {
        aviso.textContent = 'No pudimos ubicarte. Las direcciones están abajo.';
      }
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
  }

  /* ===================== PLAZO REAL POR TIENDA (el Hub) ===================== */
  var HUB_URL = 'https://zephir-hub.onrender.com/api/publico/disponibilidad';
  var TXT_HOY          = 'Recogida disponible, lista en 24 horas';
  var TXT_TRASLADO     = 'Disponible en 2 días, llega desde otra tienda';
  var TXT_CAB_HOY      = 'Normalmente está listo en 24 horas';
  var TXT_CAB_TRASLADO = 'Disponible en 2 días';
  var REINTENTO_MS = 60000;
  var cachePlazos = {};   // variantId -> { ts, mapa | false }

  function rango(t) { return t.stock === true ? 0 : 1; }

  function globo(nombre, disponible, stock) {
    var s = !disponible ? 'No disponible aquí'
          : stock === true ? 'La tiene hoy, lista en 24 horas'
          : stock === false ? 'Llega en 2 días desde otra tienda'
          : 'Disponible para recoger';
    return '<span class="zpk__globo"><b>' + nombre + '</b><span>' + s + '</span></span>';
  }

  function pedirPlazos(variantId, cb) {
    var c = cachePlazos[variantId];
    if (c && (c.mapa || Date.now() - c.ts < REINTENTO_MS)) { cb(c.mapa); return; }
    if (typeof window.fetch !== 'function') { cb(false); return; }
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var reloj = setTimeout(function () { if (ctrl) { try { ctrl.abort(); } catch (e) {} } }, 6000);
    function fin(mapa) { clearTimeout(reloj); cachePlazos[variantId] = { ts: Date.now(), mapa: mapa }; cb(mapa); }
    fetch(HUB_URL + '?variant=' + encodeURIComponent(variantId), { mode: 'cors', credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        var lista = (j && j.variantes) || [];
        var v = null;
        for (var i = 0; i < lista.length; i++) if (String(lista[i].shopify_variant_id) === String(variantId)) { v = lista[i]; break; }
        if (!v || !v.tiendas || !v.tiendas.length) { fin(false); return; }
        var mapa = {};
        for (var k = 0; k < v.tiendas.length; k++) mapa[String(v.tiendas[k].shopify_location_id)] = !!v.tiendas[k].disponible;
        fin(mapa);
      })
      .catch(function () { fin(false); });
  }

  function aplicarPlazos(ul) {
    if (!ul || ul.__zpkPlazoPedido) return;
    var variantId = ul.getAttribute('data-zpk-variant');
    if (!variantId) return;
    ul.__zpkPlazoPedido = true;
    pedirPlazos(variantId, function (mapa) {
      if (!mapa) { ul.__zpkPlazoPedido = false; return; }   // se podra reintentar mas tarde
      if (!ul.isConnected) return;
      var items = ul.querySelectorAll('[data-zpk-item]');
      var primeraHoy = null, primeraTraslado = null;
      for (var i = 0; i < items.length; i++) {
        var li = items[i];
        var hay = mapa[String(li.getAttribute('data-location-id'))];
        if (hay === undefined) continue;                       // el Hub no conoce esa tienda: manda Shopify
        var disponible = li.getAttribute('data-disponible') === '1';
        li.setAttribute('data-zpk-stock', hay ? '1' : '0');
        if (!disponible) continue;                             // Shopify dice que no: no se toca
        var estado = li.querySelector('[data-zpk-estado]');
        if (estado) estado.textContent = hay ? TXT_HOY : TXT_TRASLADO;
        if (hay && !primeraHoy) primeraHoy = li;
        if (!hay && !primeraTraslado) primeraTraslado = li;
        if (li.__zpkMarcador) { try { li.__zpkMarcador.setPopupContent(globo(li.getAttribute('data-nombre') || '', true, hay)); } catch (e) {} }
      }
      /* El titular vive en el holder (no en la ventana) y siempre habla de la
         misma variante que la lista recien inyectada. */
      var elegida = primeraHoy || primeraTraslado;
      if (elegida) {
        var cabN = document.querySelector('[data-pickup-holder] [data-zpk-cab-nombre]') || document.querySelector('[data-zpk-cab-nombre]');
        var cabP = document.querySelector('[data-pickup-holder] [data-zpk-cab-plazo]') || document.querySelector('[data-zpk-cab-plazo]');
        if (cabN) cabN.textContent = elegida.getAttribute('data-nombre') || '';
        if (cabP) cabP.textContent = primeraHoy ? TXT_CAB_HOY : TXT_CAB_TRASLADO;
      }
    });
  }

  function revisarListas() {
    var uls = document.querySelectorAll('[data-zpk-lista][data-zpk-variant]');
    for (var i = 0; i < uls.length; i++) aplicarPlazos(uls[i]);
  }

  if (typeof MutationObserver === 'function') {
    var pendiente = null;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = setTimeout(function () { pendiente = null; revisarListas(); }, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revisarListas);
  else revisarListas();

  /* ================================ EVENTOS ================================= */
  /* Un solo listener en `document`. El bloque se inyecta despues de cargar la
     pagina, se sustituye al cambiar de variante y la ventana la movemos al
     <body>: un listener atado a esos nodos moriria con ellos. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    if (e.target.closest('[data-zpk-fondo]')) { cerrarTodo(); return; }

    var abre = e.target.closest('[data-pickup-availability-popup-open]');
    if (abre) {
      abrir(ventanaDe(abre));
      revisarListas();   /* por si el observer no corrio */
      /* un poco de margen para que la ventana ya este visible cuando Leaflet mida */
      setTimeout(function () {
        var cajas = document.querySelectorAll('[data-zpk]');
        for (var i = 0; i < cajas.length; i++) preparar(cajas[i]);
      }, 80);
      return;
    }

    var boton = e.target.closest('[data-zpk-ubicar]');
    if (!boton || boton.disabled) return;
    var caja = boton.closest('[data-zpk]');
    if (caja) ubicar(caja, boton);
  });
})();